<template>
  <!-- {{ searchkey1.length }} -->
  <div class="search-container">
    <!-- Style 1 -->
    <form
      v-if="searchStyle === 'style1'"
      class="search-1"
      @submit.prevent="onSubmit"
    >
      <input
        id="input-1"
        v-model="searchkey1"
        type="search"
        class="input-1"
        name="input-1"
        autocomplete="off"
        :placeholder="labelValue"
        @paste="trimOnPaste"
        @input="onInput"
        @focus="focusValue"
        @blur="blurValue"
      />
      <label class="icon-1" for="input-1" aria-label="search">
        <i
          v-if="showClear"
          class="icon-times-circle-regular"
          style="
            position: relative;
            right: 10px;
            color: #d8d8d8;
            cursor: pointer;
          "
          @click="clearSearch"
        ></i>
        <i v-else class="icon-search-regular"></i>
      </label>
    </form>

    <!-- Style 2 -->
    <form
      v-else-if="searchStyle === 'style2'"
      class="search-2"
      @submit.prevent="onSubmit"
    >
      <input
        id="input-2"
        v-model="searchkey1"
        type="search"
        autocomplete="off"
        :placeholder="labelValue"
        @paste="trimOnPaste"
        @input="onInput"
        @focus="focusValue"
        @blur="blurValue"
      />
      <div style="width: 5%">
        <label class="icon-2" for="input-2" aria-label="search">
          <i class="icon-search-regular"></i>
        </label>
      </div>
    </form>

    <!-- Style 3 -->
    <div v-else-if="searchStyle === 'style3'" class="search-3">
      <input
        id="input-3"
        v-model="searchkey1"
        type="text"
        autocomplete="off"
        :placeholder="labelValue"
        @paste="trimOnPaste"
        @input="onInput"
        @focus="focusValue"
        @blur="blurValue"
      />
      <img class="search-3img" />
    </div>
  </div>
</template>

<script>
import debounce from "lodash/debounce";

export default {
  name: "HlxSearch",
  props: {
    labelValue: { type: String, default: "Search" },
    searchStyle: { type: String, default: "style1" },
    clearable: { type: Boolean, default: false },
    modelValue: { type: String, default: "" },
  },
  emits: ["searchKey", "blurValue", "focusValue", "update:modelValue"],
  data() {
    return {
      searchkey1: this.modelValue,
      showClear: false,
    };
  },
  watch: {
    modelValue(val) {
      this.searchkey1 = (val || "").trim();
    },
    searchkey1(val) {
      this.showClear = val.trim() !== "" && this.clearable;
    },
  },
  created() {
    // debounce only search emit (not blur/focus/clear)
    this.debouncedEmit = debounce(() => {
      this.emitChanges();
    }, 500);
  },
  beforeUnmount() {
    this.debouncedEmit.cancel();
  },
  methods: {
    trimOnPaste() {
      this.searchkey1 = this.searchkey1.trim();
    },
    onInput() {
      this.debouncedEmit();
    },
    clearSearch() {
      this.searchkey1 = "";
      this.emitChanges();
    },
    onSubmit() {
      this.debouncedEmit.cancel();
      this.emitChanges();
    },
    blurValue() {
      const val = this.searchkey1.trim();
      this.searchkey1 = val;
      this.$emit("blurValue", val);
      this.$emit("update:modelValue", val);
    },
    focusValue() {
      const val = this.searchkey1.trim();
      this.searchkey1 = val;
      this.$emit("focusValue", val);
      this.$emit("update:modelValue", val);
    },
    emitChanges() {
      const val = this.searchkey1.trim();
      this.searchkey1 = val;
      this.$emit("searchKey", val);
      this.$emit("update:modelValue", val);
    },
  },
};
</script>
